'use client';

import { __spreadArray } from '../../_virtual/_tslib.js';
import React__default, { useState, useRef } from 'react';
import useIsomorphicLayoutEffect from '../../hooks/useIsomorphicLayoutEffect.js';
import 'react-dom';
import '../../hooks/useMakeSearchable/types.js';
import '../../Utils/constants.js';
import '../../services/resumes/types.js';
import { isPhone } from '../../Utils/responsiveHelper.js';
import { ListItem, Item } from './SkillTag.css.js';
import Tag from '../../Tag/index.js';
import SimpleTooltip from '../../SimpleTooltip/index.js';

var LIMIT_ITEMS = 3;
var LIMIT_RATIO = 0.8;
var SkillTag = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b;
    var _c = useState(data ? data.filter(function (item) { return item; }) : []), listSkills = _c[0], setListSkills = _c[1];
    var _d = useState([]), hiddenSkills = _d[0], setHiddenSkills = _d[1];
    var containerRef = useRef(null);
    var isComplete = useRef(false);
    var handleSliceData = function (data, to, limit) {
        var cloneData = __spreadArray([], data, true);
        var listSkills = cloneData.slice(0, to);
        var hiddenSkills = cloneData.slice(to, limit);
        setListSkills(listSkills);
        setHiddenSkills(hiddenSkills);
        isComplete.current = true;
    };
    useIsomorphicLayoutEffect(function () {
        var _a;
        if (!isPhone())
            return;
        var filtedData = data ? data.filter(function (item) { return item; }) : [];
        if (!isComplete.current) {
            if (containerRef && containerRef.current) {
                var containerElement = containerRef.current;
                var containerWidth = containerElement.getBoundingClientRect().width;
                var parentWidth = ((_a = containerElement.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0;
                var limitWidth_1 = parentWidth * LIMIT_RATIO;
                if (containerWidth > limitWidth_1) {
                    var validWidth_1 = 0;
                    var validChildren_1 = 0;
                    Array.from(containerElement.childNodes).some(function (children) {
                        if (validWidth_1 > limitWidth_1) {
                            return true;
                        }
                        validWidth_1 += children.clientWidth;
                        validChildren_1++;
                        if (validChildren_1 > LIMIT_ITEMS)
                            return true;
                        return false;
                    });
                    handleSliceData(filtedData, validChildren_1 - 1, filtedData.length);
                    return;
                }
                if (filtedData.length > LIMIT_ITEMS) {
                    handleSliceData(filtedData, LIMIT_ITEMS, filtedData.length);
                }
            }
        }
    }, [data]);
    var renderHiddenSkillText = hiddenSkills.map(function (skill) { return skill; }).join(', ');
    return (React__default.createElement(ListItem, { ref: containerRef },
        listSkills.map(function (skill, index) {
            return (React__default.createElement(Item, { key: "".concat(skill, "_").concat(index) },
                React__default.createElement(Tag, { maxWidth: isPhone() ? 'unset' : '150px', size: 'extra-small', label: skill, isMobile: false, readOnly: true, isRounded: false, custom: {
                        haveBorder: false,
                        backgroundColor: '#C9CDD640',
                        color: '#6B7792'
                    } })));
        }),
        hiddenSkills.length > 0 && (React__default.createElement(Item, { key: 'hidden-skills' },
            React__default.createElement(SimpleTooltip, { content: renderHiddenSkillText, referenceElement: React__default.createElement(Tag, { size: 'extra-small', label: "+".concat(hiddenSkills.length), isMobile: false, readOnly: true, enableTooltip: false, isRounded: false, custom: {
                        haveBorder: false,
                        backgroundColor: '#C9CDD640',
                        color: '#6B7792'
                    } }) })))));
};

export { SkillTag as default };
//# sourceMappingURL=index.js.map
